import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { ROUTER_FEATURE_KEY } from './router/router.selectors';
import { NavigationActionTiming, provideRouterStore, routerReducer, RouterState } from '@ngrx/router-store';
import { SESSION_FEATURE_KEY, sessionReducer, SessionEffects } from '@aaa/emember/store-session';
import {
  JOIN_FEATURE_KEY,
  joinReducer,
  JoinConnectSuiteEffects,
  JoinMzpSystemEffects,
  JoinEffects,
  JoinMSystemEffects,
} from '@aaa/emember/store-join';
import { PAYMENT_FEATURE_KEY } from '@aaa/emember/store-payment';
import { paymentReducer } from './payment/payment.reducer';
import { STATE_FEATURE_KEY } from './states/states.selectors';
import { statesReducer } from './states/states.reducer';
import {
  QUICK_RENEW_FORM_FEATURE_KEY,
  QuickRenewEffects,
  QuickRenewConnectSuitSystemEffects,
  QuickRenewMzpSystemEffects,
  QuickRenewMSystemEffects,
  quickRenewReducer,
} from '@aaa/emember/store-quick-renew';
import { metaReducers } from './meta.reducers';
import { CustomSerializer } from './router/custom-route-serializer';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { environment } from '../../environments/environment';
import { PaymentEffects } from './payment/payment.effects';
import { validatorsReducer, VALIDATORS_FEATURE_KEY, ValidatorsEffects } from '@aaa/emember/store-validators';
import {
  ACCOUNT_FEATURE_KEY,
  accountReducer,
  AccountEffects,
  AccountConnectSuiteSystemEffects,
  AccountMSystemEffects,
  AccountMzpSystemEffects,
} from '@aaa/emember/store-account';
import {
  membershipAssociateAddReducer,
  MEMBERSHIP_ASSOCIATE_ADD_FEATURE_KEY,
  MembershipAssociateAddEffects,
  MembershipAssociateAddConnectSuitSystemEffects,
  MembershipAssociateAddMSystemEffects,
  MembershipAssociateAddMzpSystemEffects,
  MembershipAssociateAddCampanaSystemEffects,
} from '@aaa/emember/store-membership-associate-add';
import {
  membershipRenewReducer,
  MembershipRenewEffects,
  MembershipRenewConnectSuiteSystemEffects,
  MEMBERSHIP_RENEW_FEATURE_KEY,
  MembershipRenewMSystemEffects,
  MembershipRenewMzpSystemEffects,
  MembershipRenewCampanaSystemEffects,
} from '@aaa/emember/store-membership-renew';
import {
  MembershipUpgradePlanEffects,
  membershipUpgradePlanReducer,
  MEMBERSHIP_UPGRADE_PLAN_FEATURE_KEY,
  MembershipUpgradePlanConnectSuitSystemEffects,
  MembershipUpgradePlanMSystemEffects,
  MembershipUpgradePlanMzpSystemEffects,
  MembershipUpgradePlanCampanaSystemEffects,
} from '@aaa/emember/store-membership-upgrade-plan';
import {
  MembershipAutoRenewConnectSuitSystemEffects,
  MEMBERSHIP_AUTO_RENEW_FEATURE_KEY,
  membershipAutoRenewReducer,
  MembershipAutoRenewEffects,
  MembershipAutoRenewMEffects,
  MembershipAutoRenewMzpSystemEffects,
  MembershipAutoRenewCampanaSystemEffects,
} from '@aaa/emember/store-membership-auto-renew';
import {
  membershipReducer,
  MEMBERSHIP_FEATURE_KEY,
  MembershipConnectSuiteSystemEffects,
  MembershipMzpSystemEffects,
  MembershipMSystemEffects,
  MembershipEffects,
} from './membership';
import {
  MEMBERSHIP_UPDATE_FEATURE_KEY,
  MembershipUpdateEffects,
  membershipUpdateReducer,
  MembershipUpdateMSystemEffects,
} from './membership-update';
import {
  PRICE_OFFERS_FEATURE_KEY,
  PriceOffersEffects,
  PriceOffersConnectSuiteEffects,
  PriceOffersMSystemEffects,
  priceOffersReducer,
  PriceOffersMzpSystemEffects,
} from './price-offers';
import { MEMBERSHIP_OFFERS_FEATURE_KEY, membershipOffersReducer } from './membership-offers';
import { AnalyticsEffects } from './analytics';
import {
  MOBILE_RENEW_FEATURE_KEY,
  MobileRenewConnectSuiteSystemEffects,
  MobileRenewEffects,
  mobileRenewReducer,
} from './mobile-renew';
import { PriceOffersCampanaSystemEffects } from './price-offers/price-offers-campana-system.effects';
import { JoinCampanaSystemEffects } from './join/join-campana-system.effects';
import { MembershipCampanaSystemEffects } from './membership/membership-campana-system.effects';
import { QuickRenewCampanaSystemEffects } from './quick-renew/quick-renew-campana-system.effects';
import { AccountCampanaSystemEffects } from './account/account-campana-system.effects';

export const storeProviders = [
  provideStore(
    {
      [ROUTER_FEATURE_KEY]: routerReducer,
      [MEMBERSHIP_FEATURE_KEY]: membershipReducer,
      [SESSION_FEATURE_KEY]: sessionReducer,
      [JOIN_FEATURE_KEY]: joinReducer,
      [PAYMENT_FEATURE_KEY]: paymentReducer,
      [STATE_FEATURE_KEY]: statesReducer,
      [VALIDATORS_FEATURE_KEY]: validatorsReducer,
      [QUICK_RENEW_FORM_FEATURE_KEY]: quickRenewReducer,
      [ACCOUNT_FEATURE_KEY]: accountReducer,
      [MEMBERSHIP_ASSOCIATE_ADD_FEATURE_KEY]: membershipAssociateAddReducer,
      [MEMBERSHIP_RENEW_FEATURE_KEY]: membershipRenewReducer,
      [MEMBERSHIP_UPGRADE_PLAN_FEATURE_KEY]: membershipUpgradePlanReducer,
      [MEMBERSHIP_AUTO_RENEW_FEATURE_KEY]: membershipAutoRenewReducer,
      [MEMBERSHIP_OFFERS_FEATURE_KEY]: membershipOffersReducer,
      [MEMBERSHIP_UPDATE_FEATURE_KEY]: membershipUpdateReducer,
      [PRICE_OFFERS_FEATURE_KEY]: priceOffersReducer,
      [MOBILE_RENEW_FEATURE_KEY]: mobileRenewReducer,
    },
    { metaReducers },
  ),
  provideRouterStore({
    serializer: CustomSerializer,
    navigationActionTiming: NavigationActionTiming.PreActivation,
    routerState: RouterState.Minimal,
  }),
  provideStoreDevtools({ maxAge: 25, logOnly: environment.production, connectInZone: true }),
  provideEffects([
    MembershipEffects,
    MembershipConnectSuiteSystemEffects,
    MembershipMzpSystemEffects,
    MembershipMSystemEffects,
    MembershipCampanaSystemEffects,
    SessionEffects,
    PriceOffersEffects,
    PriceOffersMSystemEffects,
    PriceOffersConnectSuiteEffects,
    PriceOffersMzpSystemEffects,
    PriceOffersCampanaSystemEffects,
    JoinConnectSuiteEffects,
    JoinMzpSystemEffects,
    JoinMSystemEffects,
    JoinCampanaSystemEffects,
    JoinEffects,
    PaymentEffects,
    ValidatorsEffects,
    QuickRenewEffects,
    QuickRenewConnectSuitSystemEffects,
    QuickRenewMzpSystemEffects,
    QuickRenewMSystemEffects,
    QuickRenewCampanaSystemEffects,
    AccountEffects,
    AccountConnectSuiteSystemEffects,
    AccountMSystemEffects,
    AccountMzpSystemEffects,
    AccountCampanaSystemEffects,
    MembershipAssociateAddEffects,
    MembershipAssociateAddConnectSuitSystemEffects,
    MembershipAssociateAddMSystemEffects,
    MembershipAssociateAddMzpSystemEffects,
    MembershipAssociateAddCampanaSystemEffects,
    MembershipRenewEffects,
    MembershipRenewMSystemEffects,
    MembershipRenewConnectSuiteSystemEffects,
    MembershipRenewMzpSystemEffects,
    MembershipRenewCampanaSystemEffects,
    MembershipUpgradePlanEffects,
    MembershipUpgradePlanConnectSuitSystemEffects,
    MembershipUpgradePlanMzpSystemEffects,
    MembershipUpgradePlanMSystemEffects,
    MembershipUpgradePlanCampanaSystemEffects,
    MembershipAutoRenewEffects,
    MembershipAutoRenewConnectSuitSystemEffects,
    MembershipAutoRenewMEffects,
    MembershipAutoRenewMzpSystemEffects,
    MembershipAutoRenewCampanaSystemEffects,
    MembershipUpdateEffects,
    MembershipUpdateMSystemEffects,
    AnalyticsEffects,
    MobileRenewConnectSuiteSystemEffects,
    MobileRenewEffects,
  ]),
];
